import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

export default function useChatbotConfig() {
  const contextData = useContext(AuthContext);

  const user = contextData.user;

  const server = contextData.server;

  const botSelected = contextData.botSelected;

  const bots = contextData.bots;
  const hasBots = bots && bots.length > 0;

  const botId = botSelected?.id;

  const userRole = botSelected?.role;

  const botName = botSelected?.name;

  const botPlan = botSelected?.bot_plan;

  const botPermissions = botSelected?.permissions;

  const botIntegrations = {
    facebook: botSelected?.integrations?.facebook,
    whatsapp: botSelected?.phone,
  };

  return {
    ...contextData,
    user,
    bots,
    hasBots,
    botSelected,
    botId,
    botName,
    userRole,
    botPlan,
    botPermissions,
    botIntegrations,
    server,
  };
}
